export default function isVacant(name: string): boolean {
  return name.toLowerCase().includes('vacant');
}
